/**
 * Created by hp on 2017/4/26.
 */

// window.addEventListener('error', err => alert(err.message))

if(!window.console){
    window.console = {
        log: function(){}
    }
}

import 'babel-polyfill'
// import 'core-js/fn/array'
// import 'core-js/fn/object'
// import 'core-js/fn/promise'
import smoothscrollPolyfill from 'smoothscroll-polyfill'
import Raven from 'raven-js'

smoothscrollPolyfill.polyfill()
// 线上才打开sentry
if (isProdMainHost) {
    Raven.config('https://12af4f3eb1234d188b44e8a286b0d8c7@sentry.weike.fm/5', {
        ignoreErrors: [
            'WeixinJSBridge is not defined',
            'Network Error',
            'code 401',
            'Maximum call stack size exceeded',
        ]
    }).install()
}

import React from 'react'
import ReactDOM from 'react-dom'
import {browserHistory} from 'react-router'
import {Provider} from 'react-redux'
// import FastClick from 'fastclick'
import axios from 'axios'

import store from './store'
import route from './route';
import Config, {isProdMainHost} from './config'
import Session from './services/Session'

import {getJsonFromUrl, setToken, getToken, isLZWKAPP, isLZWKAPPIpad} from './utils'

import 'weui'
import 'react-weui/lib/react-weui.min.css'
import './styles/font/iconfont.css'
import './styles/index.css'
import './css/wkCommon.css'


// set platform
if (/MicroMessenger/.test(navigator.userAgent) && !/WindowsWechat/.test(navigator.userAgent)) {
    window.platform = 'weixin'
} else if (/alipay/.test(navigator.userAgent.toLowerCase())) {
    window.platform = 'alipay'
} else {
    window.platform = 'pc'
}


// set device
if (navigator.userAgent.indexOf('iP') > -1) {
    window.systemType = 'ios'
} else if (navigator.userAgent.toLowerCase().indexOf('android') > -1) {
    window.systemType = 'android'
} else {
    window.systemType = 'unknown'
}

var params = getJsonFromUrl()
// login with token
if (isLZWKAPP() || isLZWKAPPIpad() || process.env.NODE_ENV !== 'production') {
    var token = params.__token
    if (token) {
        setToken(token)
    }
}

// Landing Path, Fix Wechat Pay
window.landingPath = window.location.pathname

// initialize pgy axios
window.axiosPgy = axios.create({
    baseURL: Config.PGY_API_URL
})
// initialize admin axios
window.axiosAdmin = axios.create({
    baseURL: Config.WK_ADMIN_API
})
// initialize auth axios
window.axiosAuth = axios.create({
    baseURL: Config.AUTH_URL 
})
// initialize msg axios
window.axiosMsg = axios.create({
    baseURL: Config.MSG_API_URL
})


//判断到没有上一页时，自动将首页设为上一页
let referrer = document.referrer;
let shouldAddRef = referrer === '' && window.location.pathname !== '/' && !(isLZWKAPP() || isLZWKAPPIpad()) /*&& history && history.length <= 1*/

if (/lecture|channel|liveroom/.test(window.location.pathname)){
    shouldAddRef = false
}

if (/liveroom\/23719500/.test(window.location.pathname)){
    shouldAddRef = false
}

if (/liveroom\/23697056/.test(window.location.pathname)){
    shouldAddRef = false
}

if (/liveroom\/vip/.test(window.location.pathname) && /23697056/.test(window.location.search)){
    shouldAddRef = false
}

//app 帮助页面 打卡不返回首页 
//安卓帮助页面ua 里没有加lycheer 用window.WKApp判断
// TODO 这块暂时不修改，改了也不好测试。
const questionReg = location.hostname === 'm.lizhiweike.com' ? /https:\/\/m.lizhiweike.com\/question/ : /http:\/\/dbg.weike.fm\/question/
if((isLZWKAPP() || isLZWKAPPIpad() || window.WKApp) && questionReg.test(window.location)){
    shouldAddRef = false
}

// 蒲公英商城过来的链接
if (/pgy/.test(window.location.search)) {
    shouldAddRef = false
}

if (params && params.isMinaApp) {
    shouldAddRef = false
}

if (shouldAddRef && !/timeline/.test(window.location.search)){
    let real_url = window.location.href;
    let query = {from: 'pushstate'};
    history.replaceState(query, '十方教育', '/specials/newindexpage/?from=outside_site');
    history.pushState(null, '十方教育', real_url);
    window.addEventListener("popstate", function(e) {
        window.MtaH5 && window.MtaH5.clickStat('to_index_fr_onepage');
    }, false);
}

// render
async function main() {
    // add session, app端不采用新授权接口
    if (!(isLZWKAPP() || isLZWKAPPIpad())) {
        let session = new Session();
        await session.login();
    }

    // initialize wk axios
    axios.defaults.baseURL = Config.BASE_URL
    axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
    axios.interceptors.request.use((config) => {
        config.headers.common.Authorization = config.headers.common.Authorization ? config.headers.common.Authorization : getToken()
        return config
    })
    axios.interceptors.response.use(undefined, (error) => {
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    if (params.__ticket) return 
                    const _l = browserHistory.getCurrentLocation()
                    const next = _l.pathname + _l.search
                    const url = window.location.origin + next
                    window.location.href = `${Config.AUTH_URL}/oauth2/authorize?client_id=${Config.CLIENT_ID}&response_type=cookie&redirect_uri=` + encodeURIComponent(url)
                    return
                default:
                    break
            }
        }
        return Promise.reject(error)
    })
  
    ReactDOM.render(
        <Provider store={store}>
            {route}
        </Provider>,
        document.getElementById('root')
    )
}
main();

// initialize fastclick
// FastClick.attach(document.body)
document.addEventListener('touchstart', e => e)



/* 针对安卓手机，录音过程中禁止菜单 */
window.oncontextmenu = function (event) {
    if (event.target.nodeName === 'COMPONENT') {
        event.preventDefault();
        event.stopPropagation();
        return false;
    }
}

window.onerror = function (sMsg, sUrl, sLine, sCol, errObj) {
    try {
        if (window.errorReported)
            return
        // Get stack trace from error object
        if (errObj) {
            sMsg += '\n' + errObj.stack.toString();
        }
        if (sMsg.toString().indexOf('WeixinJSBridge') > -1)
            return;
        if (sMsg.toString().indexOf('_WXJS') > -1)
            return;

        window.errorReported = true
    } catch (e) {
        //...
    }
}


/* 去掉Splash加载画面 */
if (navigator.appName === "Microsoft Internet Explorer") {
    document.getElementById('splash').removeNode(true);
} else {
    document.getElementById('splash').remove();
}



// WEBPACK FOOTER //
// ./src/index.js